import { functions } from '@/firebase'
import { traceHttpsCallable } from '@/utils/sentry'
import type { RedeemPasswordRecoveryBridgeRequest } from '@gh/common/models'

type RedeemPasswordRecoveryBridgeResponse = {
  success: boolean
  oobCode: string
}

export const Auth = {
  redeemPasswordRecoveryBridge: traceHttpsCallable<
    RedeemPasswordRecoveryBridgeRequest,
    RedeemPasswordRecoveryBridgeResponse
  >(functions, 'redeemPasswordRecoveryBridge'),
}
